const MaskHelper = {
  date: (format) => {
    let mask = null;

    if (format === 'DD/MM/YYYY') {
      mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    } else if (format === 'DD-MM-YYYY') {
      mask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
      mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    }

    return mask;
  },

  CPF: () => {
    return [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];
  },

  CNPJ: () => {
    // Alphanumeric CNPJ (Brazil, from July 2026): first 12 positions accept
    // letters and digits; the last 2 check digits remain numeric.
    const alnum = /[A-Za-z0-9]/;
    return [
      alnum,
      alnum,
      '.',
      alnum,
      alnum,
      alnum,
      '.',
      alnum,
      alnum,
      alnum,
      '/',
      alnum,
      alnum,
      alnum,
      alnum,
      '-',
      /\d/,
      /\d/,
    ];
  },

  phone: (country = '31') => {
    switch (country) {
      case '31':
        // Fixo ou celular (dinâmico)
        return (value) => {
          const digits = value.replace(/\D/g, '');

          // Celular: (11) 91234-5678
          if (digits.length > 10) {
            return [
              '(',
              /\d/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ];
          }

          // Fixo: (11) 1234-5678
          return [
            '(',
            /\d/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ];
        };

      case '233':
        // (201) 555-0123
        return [
          '(',
          /\d/,
          /\d/,
          /\d/,
          ')',
          ' ',
          /\d/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ];

      case '177':
        // 912 345 678
        return [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/];

      case '11':
        // 11 2345-6789
        return [
          /\d/,
          /\d/,
          ' ',
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          '-',
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ];

      default:
        // Fallback: só números (até 15 dígitos - padrão E.164 sem +)
        return Array(15).fill(/\d/);
    }
  },

  passport: (countryCode) => {

    const PASSPORT_PATTERNS = {
    
      // EUA / Europa
      US: 'AAAAAAAAA', // alfanumérico
      CA: 'AA999999',
      GB: '999999999',
      FR: '99AA99999',
      DE: 'AAAAAAAAA',
      ES: 'AAA999999',
      IT: 'AA9999999',
      PT: 'A999999',
      IN: 'A9999999',
      AU: 'A9999999',
      RU: '999999999',
      KR: 'A99999999',

      // LATAM
      BR: 'AA999999',
      AR: 'AAA999999',
      CL: 'A9999999',
      UY: 'AA999999',
      PY: 'A9999999',
      BO: 'AA999999',
      PE: 'AA9999999',
      CO: 'AA9999999',
      VE: 'AA999999',
      EC: 'AA999999',
      CR: 'A99999999',
      PA: 'A9999999',
      MX: 'A99999999',
      GT: 'AA999999',
      HN: 'A9999999',
      NI: 'A9999999',
      SV: 'A9999999',
      DO: 'AA999999',

      // Ásia
      CN: 'A99999999', // E / G / P + números
      JP: 'AA9999999',

      // África
      ZA: 'AAAAAAAAA',
      NG: 'AA9999999',
      EG: 'A99999999',
      MA: 'AA999999',
      TN: 'AA999999',
      DZ: 'AA999999',
      KE: 'A9999999',
      GH: 'A9999999',
      UG: 'A9999999',
      TZ: 'A9999999',
      ET: 'A9999999',
      RW: 'A9999999',
      SN: 'AA999999',
      CI: 'AA999999',
      CM: 'AA999999',
      ZW: 'AA999999',
    };

    const pattern = PASSPORT_PATTERNS[countryCode];

    const maskFromPattern = (pat) => {
      if (!pat) return false;

      return pat.split('').map(char => {
        if (char === '9') return /\d/;
        if (char === 'A') return /[A-Za-z0-9]/;
        return char;
      });
    };

    return maskFromPattern(pattern);
  },
};

export default MaskHelper;
